// extracted by mini-css-extract-plugin
export default {"login":"Login_login__Vw+bb","login-button":"Login_login-button__OdCuW"};